import { ErrorResponse, SupplierTypeEnum, UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllSupplierResponseModel, CommonResponse, EmployeeRequest, FarmerColumns, FarmerModel, FarmerRequest, FarmerResponseModel, FarmersDropDownDto, FarmersDropDownResponseModel, FarmersRequestModel, MasterInfoFromIndentResponse, MasterInfoModel, SizesDropDownDto, SupplierDTO, SupplierFarmResponse, SupplierResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { In, Raw, Repository, getManager } from 'typeorm';
import { EmployeeDetailsService } from '../employee-details/employee-details.service';
import { ProductRequest } from '../products/dto/product.request';
import { ProductsService } from '../products/products.service';
import { FarmersModel } from './dto/farmers.model';
import { FarmersRequest } from './dto/farmers.request';
import { MasterInfoFromIndentDto } from './dto/master-info-indent.dto';
import { SupplierRepo } from './dto/supplier.repositry';
import { SuppliersAdapter } from './dto/suppliers.adapter';
import { SuppliersDTO } from './dto/suppliers.dto';
import { SupplierRequest } from './dto/suppliers.request';
import { SupplierTypeRequest } from './dto/type.request';
import { Farm } from './farms.entity';
import { Supplier } from './supplier.entity';
import { Console } from 'console';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { SupplierLog } from './suppliers-log-entity';
import { FarmsLog } from './farms-log-entity';
import { Certificates } from '../certificates/certificates.entity';
import { exists } from 'fs';

@Injectable()
export class SuppliersService {
    constructor(
      private logService:LogsService,
        private supplierRepository: SupplierRepo,
        @InjectRepository(Farm) private farmRepository: Repository<Farm>,
        private supplierAdadpter: SuppliersAdapter,
        private productService: ProductsService,
        private employeeService: EmployeeDetailsService

    ) { }


    /**
     * create or update Supplier
     * @param suppliersDTO 
     * @param isUpdate 
     */
    async createSupplier(supplierDto: SuppliersDTO, isUpdate: boolean): Promise<SupplierResponseModel> {
        try {
            // to check whether Customer exists with the passed  Customer  or not. if isUpdate is false, a check will be done whether a record with the passed Customer is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Customer  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
                const EndCustomerEntity = await this.getDuplicateSupplier(supplierDto.supplierCode);
                if (EndCustomerEntity) {
                    throw new ErrorResponse(11104, 'Supplier already exists');
                }

                if (supplierDto.supplierCategory == SupplierTypeEnum.FARMER) {
                    if (supplierDto.farmInfo) {
                        for (const farm of supplierDto.farmInfo) {
                            const formEntity = await this.getDuplicateFarm(farm.farmCode);
                            if (formEntity) {
                                throw new ErrorResponse(11104, 'Farm Code already exists');
                            }
                        }
                    }
                }
                if (supplierDto.supplierCategory === SupplierTypeEnum.AGENT) {
                    const supplierDetails = await this.supplierRepository.getAgentCode();
                    if (supplierDetails) {
                        const lastEmpCode = supplierDetails.supplierCode;
                        supplierDto.supplierCode = "A" + (Number(lastEmpCode.toString().slice(1)) + 1);
                    } else {
                        supplierDto.supplierCode = "A1";
                    }
                } if (supplierDto.supplierCategory === SupplierTypeEnum.DEALER) {
                    const supplierDetails = await this.supplierRepository.getBrokerCode();
                    if (supplierDetails) {
                        const lastEmpCode = supplierDetails.supplierCode;
                        supplierDto.supplierCode = "D" + (Number(lastEmpCode.toString().slice(1)) + 1);
                    } else {
                        supplierDto.supplierCode = "D1";
                    }
                } else if (supplierDto.supplierCategory === SupplierTypeEnum.FARMER) {
                    const supplierDetails = await this.supplierRepository.getFarmerCode();
                    if (supplierDetails) {
                        const lastEmpCode = supplierDetails.supplierCode;
                        supplierDto.supplierCode = "F" + (Number(lastEmpCode.toString().slice(1)) + 1);
                    } else {
                        supplierDto.supplierCode = "F1";
                    }
                }
            } else {
                const supplierEntity = await this.getDuplicateSupplier(supplierDto.supplierCode);
                if (supplierEntity) {
                    if (supplierEntity.supplierId != supplierDto.supplierId) {
                        throw new ErrorResponse(11104, 'Supplier already exists');
                    }
                }

                if (supplierDto.supplierCategory == SupplierTypeEnum.FARMER) {
                    if (supplierDto.farmInfo) {
                        for (const farm of supplierDto.farmInfo) {
                            const formEntity = await this.getDuplicateFarm(farm.farmCode);
                            if (formEntity) {
                                if (formEntity.farmId != formEntity.farmId) {
                                    throw new ErrorResponse(11104, 'Farm Code already exists, unable to update');
                                }
                            }
                        }
                    }
                }
            }

            const convertedEndCustomerEntity: Supplier = this.supplierAdadpter.convertDtoToEntity(supplierDto, isUpdate);
            const savedEndCustomerEntity: Supplier = await this.supplierRepository.save(
                convertedEndCustomerEntity
            );

            const savedsupplierDto: SuppliersDTO = this.supplierAdadpter.convertEntityToDto(savedEndCustomerEntity);
            if (savedsupplierDto) {

                if (supplierDto.supplierCategory == SupplierTypeEnum.DEALER) {
                    if (supplierDto.Farmers && supplierDto.Farmers.length) {
                        for (const farmerId of supplierDto.Farmers) {
                            await this.supplierRepository.update({ supplierId: farmerId }, { brokerId: savedsupplierDto.supplierId })
                        }
                    }
                }
                const response = new SupplierResponseModel(true, isUpdate ? 11101 : 11100, isUpdate ? 'Supplier Updated Successfully' : 'End Supplier Created Successfully', savedsupplierDto);
                const name=isUpdate?'updated':'created'    
                const newLogDto = new LogsDto(1,name, 'Supplier', savedsupplierDto.supplierId, true, '','','','',)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } 
          
            else {
                throw new ErrorResponse(11106, 'Supplier saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            throw error;
        }
    }

    /**
    * get supplier by id
    * @param endCustomerName 
    */
    // @LogActions({isAsync: true})
    async getDuplicateSupplier(supplierCode: string): Promise<Supplier> {
        // tslint:disable-next-line: typedef
        const supplierRes = await this.supplierRepository.findOne({
            where: { supplierCode: Raw(alias => `code = '${supplierCode}'`) },
        });
        if (supplierRes) {
            return supplierRes;
        } else {
            return null;
        }
    }

    async getDuplicateFarm(supplierCode: string): Promise<Farm> {
        // tslint:disable-next-line: typedef
        const supplierRes = await this.farmRepository.findOne({
            where: { farmCode: Raw(alias => `code = '${supplierCode}'`) },
        });
        if (supplierRes) {
            return supplierRes;
        } else {
            return null;
        }
    }

    //get farmers against broker
    async getfarmersByBrokerId(supplierReq: FarmerRequest): Promise<FarmersDropDownDto> {
        const farmerEntities = await this.supplierRepository.findOne({
            select: ['supplierId', 'supplierName', 'supplierCode'],
            where: { supplierId: supplierReq.brokerId }
        });
        console.log(farmerEntities);
        if (farmerEntities) {
            const response = new FarmersDropDownDto(farmerEntities.supplierId, farmerEntities.supplierCode, farmerEntities.supplierName);
            return response;
        } else {
            throw new ErrorResponse(11106, 'Something went wrong');
        }

    }

    //get farmers 
    async getfarmers(): Promise<FarmersDropDownResponseModel> {
        try {
            const farmerDto: FarmersDropDownDto[] = [];
            const supplierEntities: Supplier[] = await this.supplierRepository.find({ select: ['supplierId', 'supplierCode', 'supplierName'], where: { isActive: true, supplierCategory: SupplierTypeEnum.FARMER }, order: { supplierName: 'ASC' } });
            if (supplierEntities && supplierEntities.length > 0) {
                supplierEntities.forEach(supplierEntity => {
                    farmerDto.push(new FarmersDropDownDto(supplierEntity.supplierId, supplierEntity.supplierCode, supplierEntity.supplierName));
                });
                const response = new FarmersDropDownResponseModel(true, 11108, "Sizes retrieved successfully", farmerDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }

    }
    /**
     * 
     * @returns AllSupplierResponseModel
     */
    async getAllSuppliers(req?:UserRequestDto): Promise<AllSupplierResponseModel> {
        try {
            const supplierDTO: SupplierDTO[] = [];
            const supplierEntities: Supplier[] = await this.supplierRepository.find({ relations: ['farmInfo'], order: { 'supplierName': 'ASC' } });
            if (supplierEntities) {
                for (const supplierEntity of supplierEntities) {
                    const getFarmers = await this.supplierRepository.find({ select: ['supplierId'], where: { brokerId: supplierEntity.supplierId } });
                    const farmerArray: number[] = [];
                    getFarmers.map((farmer) => {
                        farmerArray.push(farmer.supplierId);
                    })

                    const convertedstatesDto: SupplierDTO = this.supplierAdadpter.convertEntityToDto(supplierEntity);
                    convertedstatesDto.Farmers = farmerArray;
                    convertedstatesDto.farmInfo
                    console.log(convertedstatesDto.farmInfo, '$$$$$$$$$$$$$')
                    supplierDTO.push(convertedstatesDto);


                }


                const response = new AllSupplierResponseModel(true, 11108, "Suppliers retrieved successfully", supplierDTO);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'Supplier', 0, true, 'Suppliers retrieved successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res)
                }
             
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }
    /**
     * 
     * @param supplierReq SupplierRequest
     * @returns SupplierResponseModel
     */
    async activateorDeactivateSupplier(supplierReq: SupplierRequest): Promise<SupplierResponseModel> {
        try {
            const supplierExists = await this.getSupplierById(supplierReq.supplierId);
            if (supplierExists) {
                if (supplierReq.versionFlag !== supplierExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Supplier information. Refresh and try again');
                } else {
                    const supplierStatus = await this.supplierRepository.update(
                        { supplierId: supplierReq.supplierId },
                        { isActive: supplierReq.isActive, updatedUser: supplierReq.updatedUser });

                    if (supplierExists.isActive) {
                        if (supplierStatus.affected) {
                            const supplierResponse: SupplierResponseModel = new SupplierResponseModel(true, 10115, 'Supplier is de-activated successfully');
                            return supplierResponse;
                        } else {
                            throw new ErrorResponse(10111, 'Supplier is already deactivated');
                        }
                    } else {
                        if (supplierStatus.affected) {
                            const supplierResponse: SupplierResponseModel = new SupplierResponseModel(true, 10114, 'Supplier is activated successfully');
                            return supplierResponse;
                        } else {
                            throw new ErrorResponse(10112, 'Supplier is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
    async getSupplierById(supplierId: number): Promise<Supplier> {
        const Response = await this.supplierRepository.findOne({
            where: { supplierId: supplierId },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }


    /**
     * get farmer/agents/brokers by supplier type
     * @param supplierReq 
     * @returns 
     */
    async getFarmersBySupplierType(supplierReq: SupplierTypeRequest): Promise<FarmersDropDownResponseModel> {
        const supplierRows: Supplier[] = await this.supplierRepository.find({
            select: ['supplierId', 'supplierName', 'supplierCode','antibioticsIdentifiedFarmer'],
            where: { supplierCategory: supplierReq.supplierType, isActive: true }
        });

        if (supplierRows.length === 0) {
            throw new ErrorResponse(10000, 'No records found');
        }
        const supplierArry: FarmersDropDownDto[] = [];
        supplierRows.map(supplier => {
            supplierArry.push(new FarmersDropDownDto(supplier.supplierId, supplier.supplierCode, supplier.supplierName,null,null,supplier.antibioticsIdentifiedFarmer));
        });
        return new FarmersDropDownResponseModel(true, 10000, "Suppliers retrieved successfully", supplierArry);
    }

    /**
     * get farm codes by farmer id
     * @param farmerIdReq 
     * @returns 
     */
    async getFarmCodesBySupplierId(farmerIdReq: FarmersModel): Promise<FarmersDropDownResponseModel> {
        const farmRepoResult = await this.farmRepository.find({
            select: ['farmId', 'farmName', 'farmCode'],
            where: { supplierInfo: farmerIdReq.farmerId }
        });

        if (farmRepoResult.length === 0) {
            throw new ErrorResponse(10000, 'No records found');
        }
        const farmArry: FarmersDropDownDto[] = [];
        farmRepoResult.map(farm => {
            farmArry.push(new FarmersDropDownDto(farm.farmId, farm.farmCode, farm.farmName));
        });
        return new FarmersDropDownResponseModel(true, 10000, "Farm Details retrieved successfully", farmArry);
    }

    /**
     * get supplier name and code bye supplier id
     * @param supplierIdReq 
     * @returns 
     */
    async getSupplierBySupplierId(supplierIdReq: FarmerModel): Promise<SupplierFarmResponse> {
        const supplierResp = await this.supplierRepository.findOne({
            where: { supplierId: supplierIdReq.farmerId },
        });
        const address = (supplierResp?.street ? supplierResp?.street : '') + ',' + (supplierResp?.city ? supplierResp?.city : '') + ',' + (supplierResp?.district ? supplierResp?.district : '') + ',' + (supplierResp?.state ? supplierResp?.state : '') + ',' + (supplierResp?.postalCode ? supplierResp?.postalCode : '')
        if (!supplierResp) {
            throw new ErrorResponse(10000, 'No records found');
        }
        return new SupplierFarmResponse(true, 10000, "Suppliers retrieved successfully", new FarmersDropDownDto(supplierResp.supplierId, supplierResp.supplierCode, supplierResp.supplierName, address, supplierResp.contactNumber));
    }

    /**
     * get supplier name and code bye supplier id
     * @param supplierIdReq 
     * @returns 
     */
    async getFarmerDetailsByFarmerId(supplierIdReq: FarmerModel): Promise<SupplierFarmResponse> {
        const farmResp = await this.farmRepository.findOne({
            where: { farmId: supplierIdReq.farmerId },
        });
        if (!farmResp) {
            throw new ErrorResponse(10000, 'No records found');
        }
        return new SupplierFarmResponse(true, 10000, "Suppliers retrieved successfully", new FarmersDropDownDto(farmResp.farmId, farmResp.farmCode, farmResp.farmName));
    }

    /**
     * get master related information for indent form
     * @param request 
     * @returns 
     */
    async getMastersRelatedDataFromIndent(request: MasterInfoFromIndentDto): Promise<MasterInfoFromIndentResponse> {
        console.log(request)
        let farmerResponse;
        let farmerCodeResponse;
        let productResponse;
        let assignLead1Response;
        let assignLead2Response;
        let indentByResponse;
        if (request.farmerId) {
            farmerResponse = await this.getSupplierBySupplierId(new FarmerModel(request.farmerId));
            if (!farmerResponse.status) {
                throw new ErrorResponse(10000, 'Farmer details not found');
            }
        }
        if (request.farmerCodeId) {
            farmerCodeResponse = await this.getFarmerDetailsByFarmerId(new FarmerModel(request.farmerCodeId));
            if (!farmerCodeResponse.status) {
                throw new ErrorResponse(10000, 'Farmer Code details not found');
            }
        }
        if (request.productId) {
            const productRequest = new ProductRequest();
            productRequest.productId = request.productId;
            productResponse = await this.productService.getActiveProductById(productRequest);
            if (!productResponse.status) {
                throw new ErrorResponse(10000, 'Product details not found');
            }
        }
        if (request.assignLead1) {
            assignLead1Response = await this.employeeService.getActiveEmployeesById(new EmployeeRequest(request.assignLead1));
            if (!assignLead1Response.status) {
                throw new ErrorResponse(10000, 'AssignLead 1 details not found');
            }
        }
        if (request.assignLead2){
            assignLead2Response = await this.employeeService.getActiveEmployeesById(new EmployeeRequest(request.assignLead2));
            if (!assignLead2Response.status) {
                throw new ErrorResponse(10000, 'AssignLead 2 details not found');
            }
        }
        if (request.indentBy){
            indentByResponse = await this.employeeService.getActiveEmployeesById(new EmployeeRequest(request.indentBy));
            if (!indentByResponse.status) {
                throw new ErrorResponse(10000, 'Indemnt by details not found');
            }     
        }
        return new MasterInfoFromIndentResponse(true, 10000, "Data retrieved successfully", new MasterInfoModel( farmerResponse?.data?.supplierName ? farmerResponse.data.supplierName : '', farmerResponse?.data?.supplierCode ? farmerResponse.data.supplierCode : '',farmerCodeResponse?.data?.supplierName ? farmerCodeResponse.data.supplierName : '' , farmerCodeResponse?.data?.supplierCode ? farmerCodeResponse.data.supplierCode : '', productResponse?.data?.productName ? productResponse?.data?.productName : '',assignLead1Response?.data?.employeeName ?  assignLead1Response?.data?.employeeName : '',assignLead2Response?.data.employeeName ? assignLead2Response.data.employeeName : '',farmerResponse?.data?.address ?  farmerResponse.data.address : '',farmerResponse?.data?.mobileNumber ? farmerResponse.data.mobileNumber : '',indentByResponse?.data?.employeeName ? indentByResponse.data.employeeName : ''));
    }

    async getFarmersCount(): Promise<number> {
        const farmersData = await this.supplierRepository.count({ where: { isActive: true } });
        if (farmersData) {
            return farmersData
        } else {
            return 0;
        }
    }

    /**
    * @param supplierReq 
    * @returns 
    */
    async getSuppliersByBrokerId(brokerReq: FarmersRequest): Promise<FarmersDropDownResponseModel> {
        const supplierRows: Supplier[] = await this.supplierRepository.find({
            select: ['supplierId', 'supplierName', 'supplierCode'],
            where: { brokerId: brokerReq.brokerId }
        });

        if (supplierRows.length === 0) {
            throw new ErrorResponse(10000, 'No records found');
        }
        const supplierArry: FarmersDropDownDto[] = [];
        supplierRows.map(supplier => {
            supplierArry.push(new FarmersDropDownDto(supplier.supplierId, supplier.supplierCode, supplier.supplierName));
        });
        return new FarmersDropDownResponseModel(true, 10000, "Suppliers retrieved successfully", supplierArry);
    }

    async createFarmer(req : any): Promise<FarmerResponseModel> {
        console.log(req,'pppppppppp');
        
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction()
            const flag = new Set<boolean>()
            const columnArray = []
            const updatedArray = req.data.map((obj) => {
                const updatedObj = {}
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            })
            const difference = columnArray.filter((element) => 
            !FarmerColumns.includes(element));
            console.log(difference,"difference")
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new FarmerResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === "") {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            for (const rec of convertedData) {


    const isoDate = rec?.ExpiryDate; // Assuming ExpiryDate is the date field
    const mysqlDateFormat = new Date(isoDate);
    const stockDate = rec?.DateOfStockIn; // Assuming ExpiryDate is the date field
    const stockDateFormat = new Date(stockDate);
    console.log(stockDateFormat,'ppppppppppppp');
    
                
                const exsistFarmer = await transactionManager.getRepository(Supplier).findOne({where:{supplierCode:rec.FarmerCode},relations:['farmInfo']})
                console.log(exsistFarmer,'oooooooooooooooooo');
                
                const certificate = await transactionManager.getRepository(Certificates).findOne({where:{certificateName:rec.Certification}})
                console.log(certificate,'lllllllllllllll77777777');
                if(!certificate){
                    return new FarmerResponseModel(false, 0, 'Certification not found');
                }
                if(exsistFarmer){
                     console.log(exsistFarmer,'ooooooooooooooo');
                   //supplier existed
                const exsistFarm = await transactionManager.getRepository(Farm).findOne({where:{farmCode:rec.FarmCode,supplierInfo:{supplierId:exsistFarmer.supplierId},farmName:rec.FarmerName}})
                    if(exsistFarm){


                        console.log(exsistFarm,'ooooo888888888877');
                        
                        //farm existed
                        //record updating in farm
                    const updatedFarm = await transactionManager.getRepository(Farm)
                    .update({farmId:exsistFarm.farmId},
                        {
                            address :  rec.FarmAddress,
                            numberOfPonds : rec.NoOfPonds,
                            NumberOfAcres : rec.NoOfAcres,
                            traceCode : rec.TraceCode,
                            certificationCode : rec.CertificationCode,
                            certificationId : certificate.certificateId,
                            expiryDate : mysqlDateFormat,
                            AreaUnderCultureInAcrs : rec.AreaUnderCultureInAcrs,
                            dateOfStockIn : stockDateFormat,
                            dayOfCulture : rec.DOC,
                            dealerName : rec.DealerName,
                            seed : rec.Seed,
                            feed : rec.Feed,
                            remarks : rec.Remarks,
                            comments : rec.Comments,
                            count : rec.Count,
                            qtyStock : rec.QtyOfStockIn,
                            biomassInMts : rec.BiomassInMts,
                            cultureStatus : rec.CultureStatus === 'yes' ? true : false,
                            updatedUser : req.user,
                            regNum: rec.MPEDARegistrationNo,
                            regStatus: rec.MPEDARegistrationStatus === 'yes' ? true : false,
                            farmType:rec.FarmType,
                            
                    });

                    //entry in farm log
                    if(updatedFarm.affected){
                        
                        const farmLog = new FarmsLog()
                        farmLog.farmName =  exsistFarm.farmName
                        farmLog.farmCode =  exsistFarm.farmCode
                        farmLog.address =  exsistFarm.address
                       farmLog.numberOfPonds = exsistFarm.numberOfPonds
                       farmLog.NumberOfAcres = exsistFarm.NumberOfAcres
                        farmLog.traceCode = exsistFarm.traceCode
                        farmLog.certificationCode = exsistFarm.certificationCode
                        farmLog.certificationId = certificate.certificateId
                        farmLog.expiryDate = exsistFarm.expiryDate
                        farmLog.AreaUnderCultureInAcrs = exsistFarm.AreaUnderCultureInAcrs
                        farmLog.dateOfStockIn = exsistFarm.dateOfStockIn
                        farmLog.dayOfCulture = exsistFarm.dayOfCulture
                        farmLog.dealerName = exsistFarm.dealerName
                        farmLog.seed = exsistFarm.seed
                        farmLog.feed = exsistFarm.feed
                         farmLog.remarks = exsistFarm.remarks
                        farmLog.comments = exsistFarm.comments
                        farmLog.count = exsistFarm.count
                        farmLog.qtyStock = exsistFarm.qtyStock
                        farmLog.biomassInMts = exsistFarm.biomassInMts
                        farmLog.cultureStatus = exsistFarm.cultureStatus 
                       farmLog.createdUser = exsistFarm.createdUser
                        farmLog.effectiveFrom = exsistFarm.createdAt
                        // farmLog.mobileNumber = exsistFarm.mobileNumber
                        farmLog.farmInfo = new Farm()
                        farmLog.farmInfo.farmId = exsistFarm.farmId

                        const FarmLog = await transactionManager.getRepository(FarmsLog).save(farmLog);

                        
                    }
                    //record updating in supplier table
                }
                else{

                    const updateSupplier = await transactionManager.getRepository(Supplier)
                    .update({ supplierId: exsistFarmer.supplierId },
                        {
                            state: rec.State,
                            city: rec.Place,
                            district: rec.District,
                            contactNumber: rec.ContactDetails,
                            updatedUser: req.user // not included in excel
                        });
                
                
                        
                        //entry in supplier log
                        if(updateSupplier.affected!= 0){
                            const supplierLog = new SupplierLog()
                            supplierLog.supplierInfo = new Supplier()
                            supplierLog.supplierInfo.supplierId = exsistFarmer.supplierId
                            supplierLog.supplierName =exsistFarmer.supplierName
                            supplierLog.supplierCode = exsistFarmer.supplierCode
                            supplierLog.state = exsistFarmer.state
                            supplierLog.contactPerson = exsistFarmer.contactPerson
                            supplierLog.contactNumber = exsistFarmer.contactNumber
                            supplierLog.district = exsistFarmer.district
                            supplierLog.effectiveFrom = exsistFarmer.createdAt
                            supplierLog.createdUser = exsistFarmer.createdUser
                            const LogSupplier = await transactionManager.getRepository(SupplierLog).save(supplierLog);
    
                        }
                        

                        // new rec entry in farm
                    const  entity = new Farm()
                    entity.farmName =  rec.FarmName
                    entity.farmCode =  rec.FarmCode
                    entity.address =  rec.FarmAddress
                    entity.numberOfPonds = rec.NoOfAcres
                                    entity.NumberOfAcres = rec.NoOfPonds
                                    entity.traceCode = rec.TraceCode
                                    entity.certificationCode = rec.CertificationCode
                                    entity.certificationId = certificate.certificateId
                                    entity.expiryDate = mysqlDateFormat
                                    entity.AreaUnderCultureInAcrs = rec.AreaUnderCultureInAcrs
                                    entity.dateOfStockIn = stockDateFormat
                                    entity.dayOfCulture = rec.DOC
                                    entity.dealerName = rec.DealerName
                                    entity.seed = rec.Seed
                                    entity.feed = rec.Feed
                                    entity.remarks = rec.Remarks
                                    entity.comments = rec.Comments
                                    entity.count = rec.Count
                                    entity.qtyStock = rec.QtyOfStockIn
                                    entity.biomassInMts = rec.BiomassInMts
                                    entity.cultureStatus = rec.CultureStatus === 'yes' ? true : false
                                    entity.createdUser = req.user
                                    entity.supplierInfo = exsistFarmer
                                    // entity.mobileNumber = rec.ContactDetails
                                    entity.farmType = rec.farmType
                                    entity.regNum = rec.MPEDARegistrationNo
                                    entity.regStatus = rec.MPEDARegistrationStatus === 'yes' ? true : false
                                    console.log(entity,'---------');

                    const savedData = await transactionManager.getRepository(Farm).save(entity);

                    
                    }
                   
                }
                else{
                    
                    const entity = new Supplier()
                    entity.supplierName = rec.FarmerName
                    entity.supplierCode = rec.FarmerCode
                    // entity.gstNumber = rec.MPEDARegistrationNo
                    entity.state = rec.State
                    entity.city = rec.Place
                    entity.district = rec.District
                    entity.contactNumber = rec.ContactDetails
                    entity.contactPerson = rec.FarmerName // not inclueded in excel
                    entity.createdUser = req.user // not inclueded in excel
                    // entity.updatedUser = req.updatedUser // not inclueded in excel
                    console.log(entity,'uuuu7777777777uuuuuuu');

                    const savedData = await transactionManager.getRepository(Supplier).save(entity);
                    console.log(savedData,'uuuuuuuuuuu');
                    
                    const exsistFarm = await transactionManager.getRepository(Farm).findOne({where:{farmCode:rec.FarmCode,supplierInfo:{supplierCode:rec.FarmerCode},farmName:rec.FarmName}})
                    if(exsistFarm){


                        console.log(exsistFarm,'eeeeeeeee');
                        
                        //farm existed
                        //record updating in farm
                    const updatedFarm = await transactionManager.getRepository(Farm)
                    .update({farmId:exsistFarm.farmId},
                        {
                            address :  rec.FarmAddress,
                            numberOfPonds : rec.NoOfPonds,
                            NumberOfAcres : rec.NoOfAcres,
                            traceCode : rec.TraceCode,
                            certificationCode : rec.CertificationCode,
                            certificationId : certificate.certificateId,
                            expiryDate : mysqlDateFormat,
                            AreaUnderCultureInAcrs : rec.AreaUnderCultureInAcrs,
                            dateOfStockIn : stockDateFormat,
                            dayOfCulture : rec.DOC,
                            dealerName : rec.DealerName,
                            seed : rec.Seed,
                            feed : rec.Feed,
                            remarks : rec.Remarks,
                            comments : rec.Comments,
                            count : rec.Count,
                            qtyStock : rec.QtyOfStockIn,
                            biomassInMts : rec.BiomassInMts,
                            cultureStatus : rec.CultureStatus === 'yes' ? true : false,
                            updatedUser : req.user,
                            regNum: rec.MPEDARegistrationNo,
                            regStatus: rec.MPEDARegistrationStatus === 'yes' ? true : false,
                            farmType:rec.FarmType
                    });

                    //entry in farm log
                    if(updatedFarm.affected){
                        
                        const farmLog = new FarmsLog()
                        farmLog.farmName =  exsistFarm.farmName
                        farmLog.farmCode =  exsistFarm.farmCode
                        farmLog.address =  exsistFarm.address
                       farmLog.numberOfPonds = exsistFarm.numberOfPonds
                       farmLog.NumberOfAcres = exsistFarm.NumberOfAcres
                        farmLog.traceCode = exsistFarm.traceCode
                        farmLog.certificationCode = exsistFarm.certificationCode
                        farmLog.certificationId = certificate.certificateId
                        farmLog.expiryDate = exsistFarm.expiryDate
                        farmLog.AreaUnderCultureInAcrs = exsistFarm.AreaUnderCultureInAcrs
                        farmLog.dateOfStockIn = exsistFarm.dateOfStockIn
                        farmLog.dayOfCulture = exsistFarm.dayOfCulture
                        farmLog.dealerName = exsistFarm.dealerName
                        farmLog.seed = exsistFarm.seed
                        farmLog.feed = exsistFarm.feed
                         farmLog.remarks = exsistFarm.remarks
                        farmLog.comments = exsistFarm.comments
                        farmLog.count = exsistFarm.count
                        farmLog.qtyStock = exsistFarm.qtyStock
                        farmLog.biomassInMts = exsistFarm.biomassInMts
                        farmLog.cultureStatus = exsistFarm.cultureStatus 
                       farmLog.createdUser = exsistFarm.createdUser
                        farmLog.effectiveFrom = exsistFarm.createdAt
                        // farmLog.mobileNumber = exsistFarm.mobileNumber
                        farmLog.farmInfo = new Farm()
                        farmLog.farmInfo.farmId = exsistFarm.farmId

                        const FarmLog = await transactionManager.getRepository(FarmsLog).save(farmLog);

                        
                    }
                    //record updating in supplier table
                    
                   
                }
                else{
                    console.log('rrrrrrr');
                    
                    //new supplier
                                    const entity = new Supplier()
                                    entity.supplierName = rec.FarmerName
                                    entity.supplierCode = rec.FarmerCode
                                    // entity.gstNumber = rec.MPEDARegistrationNo
                                    entity.state = rec.State
                                    entity.city = rec.Place
                                    entity.district = rec.District
                                    entity.contactNumber = rec.ContactDetails
                                    entity.contactPerson = rec.FarmerName // not inclueded in excel
                                    entity.createdUser = req.user // not inclueded in excel
                                    // entity.updatedUser = req.updatedUser // not inclueded in excel

                                    const savedData = await transactionManager.getRepository(Supplier).save(entity);
                                    const farmEntity = new Farm()
                                    farmEntity.supplierInfo = savedData
                                    farmEntity.farmName =  rec.FarmName
                                    farmEntity.farmCode =  rec.FarmCode
                                    farmEntity.address =  rec.FarmAddress
                                    farmEntity.NumberOfAcres = rec.NoOfAcres
                                    farmEntity.numberOfPonds = rec.NoOfPonds
                                    farmEntity.traceCode = rec.TraceCode
                                    farmEntity.certificationCode = rec.CertificationCode
                                    farmEntity.certificationId = certificate.certificateId
                                    farmEntity.expiryDate = mysqlDateFormat
                                    farmEntity.AreaUnderCultureInAcrs = rec.AreaUnderCultureInAcrs
                                    farmEntity.dateOfStockIn = stockDateFormat
                                    farmEntity.dayOfCulture = rec.DOC
                                    farmEntity.dealerName = rec.DealerName
                                    farmEntity.seed = rec.Seed
                                    farmEntity.feed = rec.Feed
                                    farmEntity.remarks = rec.Remarks
                                    farmEntity.comments = rec.Comments
                                    farmEntity.count = rec.Count
                                    farmEntity.qtyStock = rec.QtyOfStockIn
                                    farmEntity.biomassInMts = rec.BiomassInMts
                                    farmEntity.cultureStatus = rec.CultureStatus === 'yes' ? true : false
                                    // farmEntity.mobileNumber = rec.ContactDetails
                                    farmEntity.farmType = rec.FarmType
                                    farmEntity.regNum = rec.MPEDARegistrationNo
                                    farmEntity.regStatus = rec.MPEDARegistrationStatus === 'yes' ? true : false
                                    const savedFaram = await transactionManager.getRepository(Farm).save(farmEntity);
                                   console.log(savedFaram,'ttttttttt');
                                   
            }
    
                 }
            }
        
        // if (!flag.has(false)) {
                        await transactionManager.completeTransaction();
                        return new FarmerResponseModel(true, 1, 'Data saved successfully');
                    // } else {
                        // await transactionManager.releaseTransaction();
                        // return new FarmerResponseModel(false, 0, 'Something went wrong');
                    // }
                } catch (err) {
            await transactionManager.releaseTransaction();
            return new FarmerResponseModel(false, 0, 'Something went wrong',err);
        }
    }
    
    async getAllFarmersInfo(): Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query =`SELECT  
            s.supplier_id ,
            s.CODE AS supplierCode,
            s.NAME AS supplierName,
            s.street,
            s.city ,
            s.state,
            s.district,
            s.contact_number as contactNumber,
            f.farm_id,
            f.CODE AS farmCode,
            f.NAME AS farmName,
            f.address AS farmAddress,
            f.no_of_acres AS noOfAcr,
            f.no_of_ponds AS noOfPonds,
            f.trace_code AS traceCode,
            c.certificate_name AS certification,
            f.certification_code AS certificationCode,
            f.exp_date AS expiryDate,
            f.culture_status AS cultureStatus,
            f.dealer ,
            f.seed ,
            f.feed ,
            f.remarks ,
            f.comments ,
            f.area_under_culture_in_acrs AS cultureInAcr,
            f.qty_stock AS qtyStock,
            f.date_of_stock_in AS dataOfStockIn,
            f.day_of_culture AS doc,
            f.COUNT AS count,
            f.farm_type,
            f.reg_no,
            f.reg_status,
            f.biomass_in_mts AS biomass,
            s.updated_at as updatedAt
             FROM suppliers s
            LEFT JOIN farms f ON s.supplier_id = f.farmer_id 
            LEFT JOIN certificates c ON c.certificate_id = f.certification_id`
            const details =await manager.query(query);
            return new CommonResponse(true, 1, 'No data found',details)
          
          } catch (err) {
            throw err
          }
    }

    async getAllSuppliersNames(): Promise<CommonResponse> {
        try {
            const supplierEntities = await this.supplierRepository.find({ select: ['supplierId', 'supplierCode', 'supplierName'], where: { isActive: true}, order: { supplierName: 'ASC' } });

            if(supplierEntities.length > 0) {
                return new CommonResponse(true, 10000, 'Supplier names retrieved successfully', supplierEntities);
            }else {
                return new CommonResponse(false, 10000, 'No records found', []);
            }
        } catch (err) {
            throw err;
        }

    }
}
